import { render, staticRenderFns } from "./batchManagement.vue?vue&type=template&id=6a8603e5&scoped=true&"
import script from "./batchManagement.vue?vue&type=script&lang=js&"
export * from "./batchManagement.vue?vue&type=script&lang=js&"
import style0 from "./batchManagement.vue?vue&type=style&index=0&id=6a8603e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8603e5",
  null
  
)

export default component.exports